import React, { useEffect, useState, useContext } from "react";
import * as styledComponents from "./styles";
import { Container, Row, Col } from "react-bootstrap";
import ItemElement from "../components/ItemElement";
import DetailItem from "../components/DetailItem";
import { CombSpinner } from "react-spinners-kit";
import { CartContext } from "contexts/CartContext";
import { useAlert } from "react-alert";
import { useParams } from "react-router-dom";
import { itemsAPI, itemAPI, cmsHeaders } from "api/hosts";

interface ParamTypes {
  serviceId: string;
}

const ShopItems = () => {
  const [items, setItems] = useState([]);
  const [focusedItem, setFocusedItem] = useState(0);
  const { cart, updateCart } = useContext(CartContext);
  const { serviceId } = useParams<ParamTypes>();

  const alert = useAlert();
  useEffect(() => {
    (async () => {
      const response = await fetch(itemsAPI, cmsHeaders);
      const newItems = await response.json();
      setItems(newItems.data?.sort(() => Math.random() - 0.5));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const response = await fetch(`${itemAPI}/${serviceId}?populate=*`, cmsHeaders);
      const focusedItem = await response.json();
      setFocusedItem(focusedItem.data);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    })();
  }, [serviceId]);

  const addItemToCart = (item: any) => {
    const newCart = cart?.length ? [...cart, item] : [item];
    updateCart(newCart);
    alert.show(`${item.name} added to cart`, { type: "success" });
  };

  return (
    <styledComponents.ShopItemsContainer>
      <Container>
        <Row>
          <Col xs={12} md={8} lg={6}>
            <styledComponents.ContainerReturn to={"/shop"}>
              <styledComponents.StyledArrowDownIcon /> RETURN TO SERVICES
            </styledComponents.ContainerReturn>
            {focusedItem && (
              <DetailItem item={focusedItem} addItemToCart={addItemToCart} />
            )}
          </Col>
          <styledComponents.ContainerRelatedElements xs={12} md={4} lg={6}>
            <styledComponents.RelatedServicesLabel>
              RELATED SERVICES
            </styledComponents.RelatedServicesLabel>
            {!items?.length && (
              <styledComponents.ContainerLoader>
                <CombSpinner color="#FFFFFF" />
              </styledComponents.ContainerLoader>
            )}
            {items?.map((item, idx) => {
              return (
                <ItemElement
                  key={idx}
                  item={item}
                  addItemToCart={addItemToCart}
                />
              );
            })}
          </styledComponents.ContainerRelatedElements>
        </Row>
      </Container>
    </styledComponents.ShopItemsContainer>
  );
};

export default ShopItems;
